import { emitOpenGuestPrompt } from './guestPromptBridge';

export { GUEST_READ_ONLY_TITLE, GUEST_READ_ONLY_MESSAGE } from './guestReadOnlyCopy';

export function showGuestRegisterPrompt(logout: () => void | Promise<void>) {
  emitOpenGuestPrompt(logout);
}

/** Kısa takma ad (ekranlarda ortak kullanım) */
export const showGuestAlert = showGuestRegisterPrompt;
